(function () {
  'use strict';
  var selector = '.js-cart-form[data-hsbd-acknowledgement-required="true"]';
  var states = new WeakMap();
  var nextId = 0;
  if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;

  function fingerprint(form, state) {
    var lines = Array.from(form.querySelectorAll('.ajax-cart__cart-item')).map(function (line) {
      var input = line.querySelector('[data-item-qty]');
      return [
        line.querySelector('.ajax-cart__item-details')?.textContent || '',
        input ? input.value : line.querySelector('.ajax-cart__item-qty')?.textContent || '',
        input?.dataset.itemKey || line.dataset.hsbdPanelFee || '',
        line.querySelector('.ajax-cart__item-line-price')?.textContent || ''
      ];
    });
    return JSON.stringify([
      lines,
      form.querySelector('.ajax-cart__final-details')?.textContent || '',
      state.review.dataset.hsbdPolicyVersion,
      state.review.querySelector('.hsbd-order-review__body')?.textContent || '',
      Array.from(state.review.querySelectorAll('a')).map(function (link) { return link.href; })
    ]);
  }

  function syncContinue(state) {
    var button = state.review.querySelector('[data-hsbd-review-continue]');
    if (!button) return;
    var disable = !state.checkbox.checked;
    if (disable && document.activeElement === button && state.dialog.open) state.checkbox.focus();
    button.disabled = disable;
  }

  function init(form) {
    var state = states.get(form);
    if (state) return state;
    var review = form.querySelector('[data-hsbd-order-review]');
    var checkbox = form.querySelector('[data-hsbd-order-checkbox]');
    var checkout = form.querySelector('.ajax-cart__button-submit[name="checkout"]');
    if (!review || !checkbox || !checkout) return null;
    var dialog = document.createElement('dialog');
    dialog.className = 'hsbd-order-review-dialog';
    var title = review.querySelector('[data-hsbd-review-title]');
    title.id = 'hsbd-order-review-title-' + (++nextId);
    dialog.setAttribute('aria-labelledby', title.id);
    state = { dialog: dialog, review: review, checkbox: checkbox, checkout: checkout, returnFocus: checkout, signature: '', submitting: false };
    states.set(form, state);
    review.before(dialog);
    dialog.appendChild(review);
    checkbox.checked = false;
    syncContinue(state);
    review.querySelectorAll('[data-hsbd-review-close], [data-hsbd-review-continue]').forEach(function (button) { button.hidden = false; });
    var trigger = form.querySelector('[data-hsbd-review-open]');
    if (trigger) {
      trigger.hidden = false;
      trigger.addEventListener('click', function () { open(form, trigger); });
    }
    review.querySelectorAll('[data-hsbd-review-close]').forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('close', function () {
      if (!state.submitting) {
        checkbox.checked = false;
        syncContinue(state);
        state.signature = '';
      }
      if (state.returnFocus?.isConnected) state.returnFocus.focus();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var controls = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], summary, [tabindex="0"]')).filter(function (control) {
        return !control.hidden && control.getClientRects().length > 0;
      });
      if (!controls.length) return;
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === title)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    checkbox.addEventListener('change', function () { syncContinue(state); });
    syncContinue(state);
    review.querySelector('[data-hsbd-review-continue]').addEventListener('click', function () {
      if (!checkbox.checked) {
        checkbox.focus();
        checkbox.reportValidity();
        return;
      }
      if (state.signature !== fingerprint(form, state)) {
        checkbox.checked = false;
        syncContinue(state);
        state.signature = fingerprint(form, state);
        checkbox.focus();
        checkbox.reportValidity();
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      state.submitting = true;
      try { form.requestSubmit(state.checkout); }
      finally {
        state.submitting = false;
        checkbox.checked = false;
        syncContinue(state);
        state.signature = '';
      }
    });
    return state;
  }

  function open(form, opener) {
    var state = init(form);
    if (!state || !form.isConnected) return;
    if (!state.dialog.open) {
      state.returnFocus = opener || state.checkout;
      state.checkbox.checked = false;
      syncContinue(state);
      state.signature = fingerprint(form, state);
      state.dialog.showModal();
      state.review.querySelector('[data-hsbd-review-title]').focus();
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var checkout = event.target.closest?.('.ajax-cart__button-submit[name="checkout"]');
    var form = checkout?.form;
    if (!form?.matches(selector) || !init(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(form, checkout);
  }, true);

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest?.('.ajax-cart__button-submit[name="checkout"]');
    var form = checkout?.form;
    if (!form?.matches(selector) || !init(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(form, checkout);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches?.(selector)) return;
    var state = init(form);
    if (!state) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (state.submitting && state.checkbox.checked && state.signature === fingerprint(form, state)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(form, state.checkout);
  }, true);

  document.addEventListener('invalid', function (event) {
    if (!event.target.matches?.('[data-hsbd-order-checkbox]')) return;
    var form = event.target.form;
    var state = init(form);
    if (!state) return;
    open(form, state.checkout);
  }, true);

  document.addEventListener('input', function (event) {
    var form = event.target.closest?.(selector);
    var state = form && states.get(form);
    if (state && !event.target.matches('[data-hsbd-order-checkbox]') && state.signature !== fingerprint(form, state)) {
      state.checkbox.checked = false;
      syncContinue(state);
      state.signature = '';
    }
  }, true);

  function scan() {
    document.querySelectorAll(selector).forEach(function (form) {
      var state = init(form);
      if (state) syncContinue(state);
      if (state?.dialog.open && !state.submitting && state.signature !== fingerprint(form, state)) {
        state.checkbox.checked = false;
        syncContinue(state);
        state.signature = '';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', scan, { once: true });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll(selector).forEach(function (form) {
      var state = init(form);
      if (!state) return;
      state.checkbox.checked = false;
      syncContinue(state);
      state.signature = '';
      if (state.dialog.open) state.dialog.close();
    });
  });
  if (document.readyState !== 'loading') scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
}());
